var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Styles
import '../../../src/components/VDivider/VDivider.sass';
// Mixins
import Themeable from '../../mixins/themeable';
export default Themeable.extend({
    name: 'v-divider',
    props: {
        inset: Boolean,
        vertical: Boolean
    },
    render: function render(h) {
        // WAI-ARIA attributes
        var orientation = void 0;
        if (!this.$attrs.role || this.$attrs.role === 'separator') {
            orientation = this.vertical ? 'vertical' : 'horizontal';
        }
        return h('hr', {
            class: _extends({
                'v-divider': true,
                'v-divider--inset': this.inset,
                'v-divider--vertical': this.vertical
            }, this.themeClasses),
            attrs: _extends({
                role: 'separator',
                'aria-orientation': orientation
            }, this.$attrs),
            on: this.$listeners
        });
    }
});
//# sourceMappingURL=VDivider.js.map